module.exports = __webpack_public_path__ + "img/Light.7aa2bf69.png";